// extracted by mini-css-extract-plugin
export default {"select":"StyledReactSelect_select__X3L3I","container":"StyledReactSelect_container__J6HX2","label":"StyledReactSelect_label__Ut7cO"};